import { BaseNetworkActionValidator } from '../base.network.action.validator';
import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { ProtectedEntitiesHelper } from '../../../helpers/protectedEntities/protected.entities.helper';

export class MarkGoldenImageActionValidator extends BaseNetworkActionValidator {
  protected canRunForMultipleItems = false;
  protected canRunForUnmanagedCompanies = false;
  protected requiresTasksEnabled = false;
  protected canRunOnMultipleCompanies = false;

  protected _canPerformAction(record: ProtectedEntity): boolean {
    if (
      !ProtectedEntitiesHelper.isComputer(record) ||
      !ProtectedEntitiesHelper.isManaged(record) ||
      !ProtectedEntitiesHelper.isVirtual(record) ||
      ProtectedEntitiesHelper.isSva(record) ||
      ProtectedEntitiesHelper.isGoldenImage(record)
    ) {
      return false;
    }

    return true;
  }
}
